module.exports = __webpack_public_path__ + "img/logo.024aa7d9.png";